import { SVGProps } from 'react';

export const PlantIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="50"
		height="50"
		viewBox="0 0 42 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_378_490)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.0355664 0.389648C0.0583711 0.603914 0.0988125 1.05615 0.125555 1.39453C0.207258 2.43009 0.400031 3.82881 0.662531 5.29102C1.98619 12.6637 4.88279 17.7956 8.85737 19.8096C10.057 20.4176 11.8235 20.8307 13.2394 20.8345L13.8052 20.8359L13.7486 19.9604C13.5879 17.4743 12.693 14.0241 11.477 11.2018C11.3031 10.7982 11.1722 10.4564 11.1862 10.4424C11.2478 10.3809 13.2215 13.3026 14.1897 14.8887C16.3711 18.462 18.2482 22.5191 19.1238 25.5527C20.1227 29.0138 20.6404 33.0834 20.7987 38.7188C20.841 40.2221 20.8774 40.6253 20.9952 40.8926C21.3001 41.5846 21.9501 41.9952 22.7456 41.9982C23.8212 42.0023 24.5466 41.3272 24.6596 40.2168C24.7241 39.5839 24.5613 35.4076 24.3999 33.5537L24.2705 32.0667L24.487 31.2021C25.0965 28.7676 25.5541 27.7347 27.589 24.1992C28.8503 22.008 30.2602 20.0448 31.8249 18.3013C32.445 17.6103 34.2679 15.9141 34.3904 15.9141C34.4263 15.9141 34.2762 16.1447 34.0569 16.4268C32.1948 18.8203 31.0364 21.3645 30.7276 23.7394L30.686 24.0588L31.6877 24.0121C34.5434 23.8791 36.7899 22.5316 38.5624 19.8885C40.2401 17.3868 41.4577 13.3913 41.8718 9.02861C41.9422 8.28696 41.9998 7.65073 41.9998 7.6148C41.9998 7.57879 41.7691 7.5696 41.4871 7.59421C35.2665 8.13799 30.5354 9.77632 27.8528 12.3156C26.9421 13.1777 26.4776 13.8011 25.997 14.8066C25.5394 15.7639 25.3851 16.3154 25.2552 17.4581C25.1543 18.3451 25.2387 19.5399 25.4734 20.5467C25.6018 21.098 25.6615 20.9722 24.8501 21.8613C24.3596 22.3988 23.6562 23.3601 23.2329 24.0718C23.0284 24.4155 22.8786 24.5946 22.8556 24.523C22.0811 22.1149 21.6277 20.9392 20.9589 19.6058C20.711 19.1113 20.3572 18.4602 20.1728 18.159L19.8376 17.6113L20.0152 16.9062C20.6395 14.4282 20.6539 12.1679 20.058 10.1771C18.69 5.60684 13.8535 2.30204 6.25772 0.747305C4.28577 0.343629 1.64781 0 0.52152 0H-0.00585938L0.0355664 0.389648Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_378_490">
				<rect width="42" height="42" fill="currentColor" />
			</clipPath>
		</defs>
	</svg>
);

export const SuppliesIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="50"
		height="50"
		viewBox="0 0 42 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.4331 3.56114C12.9719 3.72709 12.738 3.90575 12.4889 4.28211C12.2923 4.57915 12.2634 4.70318 12.2634 5.25C12.2634 5.79912 12.292 5.92028 12.4923 6.22305C12.7547 6.61959 13.0971 6.8556 13.5964 6.9843L13.9451 7.07413V11.9774V16.8806L9.91381 23.4273C7.69667 27.028 5.79412 30.174 5.68609 30.4183C5.37675 31.1178 5.25231 31.7941 5.25099 32.7828C5.25001 33.5213 5.28996 33.8359 5.4596 34.4234C6.02471 36.3811 7.45132 37.8234 9.35789 38.3643C9.85557 38.5055 10.4952 38.5137 20.9998 38.5137C31.5044 38.5137 32.144 38.5055 32.6416 38.3643C35.135 37.6569 36.7523 35.4411 36.7485 32.7379C36.7471 31.7528 36.6123 31.0757 36.2691 30.3317C36.139 30.0494 34.2374 26.9074 32.0435 23.3496L28.0545 16.8808V11.9775V7.07413L28.4031 6.9843C28.9024 6.8556 29.2448 6.61959 29.5072 6.22305C29.7082 5.91937 29.7361 5.79977 29.7361 5.24253C29.7361 4.66791 29.7125 4.57423 29.4864 4.25217C29.349 4.05653 29.0721 3.8042 28.8712 3.69141L28.5056 3.48633L21.1228 3.46853C15.108 3.45401 13.6832 3.47123 13.4331 3.56114ZM24.4487 12.3662C24.4515 16.4635 24.4762 17.7434 24.557 17.9648C24.6146 18.1228 25.2758 19.2486 26.0262 20.4668L27.3907 22.6816L24.1952 22.7031C22.4377 22.7149 19.5613 22.7149 17.8033 22.7031L14.6067 22.6816L15.9997 20.4258C16.7658 19.1851 17.4289 18.0407 17.4731 17.8828C17.5218 17.7089 17.5537 15.518 17.554 12.3252L17.5545 7.05469H20.9998H24.4451L24.4487 12.3662Z"
			fill="currentColor"
		/>
	</svg>
);

export const CoffeeIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="50"
		height="50"
		viewBox="0 0 42 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.5432 2.63947C12.1748 4.00276 8.68169 9.26956 8.72898 14.4216C8.74889 16.5856 9.29863 18.5264 9.87823 18.48C10.0923 18.4629 11.226 18.4277 12.3976 18.4022L14.5284 18.3556L15.0607 17.0333C15.3535 16.306 15.729 14.3111 15.8954 12.6C16.2862 8.57951 17.143 6.03742 19.1291 3.00658L19.672 2.17778L18.7807 2.19862C18.2904 2.21014 17.2836 2.40831 16.5432 2.63947ZM21.0288 4.13529C19.4402 6.21818 18.6578 8.50422 18.2188 12.348C17.9876 14.369 17.5785 16.6224 17.3094 17.356L16.82 18.6894L17.6656 18.9946C18.1311 19.1623 19.0566 19.5375 19.723 19.8284L20.9345 20.3569L22.1264 19.0142C25.99 14.6599 26.5986 7.83814 23.4355 4.33689C22.8264 3.66271 22.2116 3.11111 22.0691 3.11111C21.9266 3.11111 21.4584 3.57187 21.0288 4.13529ZM29.4935 11.9893C27.8328 12.5176 27.7575 12.6047 26.9775 14.8994C26.3565 16.7272 24.6678 19.5683 23.3979 20.9222L22.5952 21.7778L23.396 22.6333C23.8365 23.104 24.4703 24.0321 24.8041 24.696L25.4111 25.9028L26.7087 24.5523C27.4414 23.7897 28.6777 21.8412 29.5473 20.0785C31.0727 16.9864 32.8429 14.7451 35.1467 12.9892C35.7403 12.5365 36.1139 12.0543 35.9773 11.9177C35.516 11.456 31.0129 11.5058 29.4935 11.9893ZM36.7508 14.6297C34.363 16.3595 32.9235 18.1372 31.5039 21.1108C30.4585 23.2997 29.5818 24.5815 27.9684 26.2802C25.5296 28.8475 25.2421 29.7712 26.8338 29.9248C30.7314 30.3007 35.156 28.0398 37.6676 24.3892C38.8784 22.6296 39.8227 19.8872 39.8227 18.1312C39.8227 16.8062 38.7369 13.6889 38.2755 13.6889C38.1511 13.6889 37.4651 14.1123 36.7508 14.6297ZM8.69507 21.2243C7.57383 21.6176 6.07645 22.3991 5.36711 22.9606C4.06107 23.9951 2.26192 27.0692 2.62187 27.6516C2.95072 28.1836 6.29298 28.7034 8.14191 28.5102C9.1188 28.4082 11.1516 27.8737 12.6592 27.3227C15.197 26.395 15.6926 26.3197 19.3372 26.3094L23.274 26.2982L22.8628 25.5158C22.1565 24.1715 20.1427 22.4669 18.2275 21.5924C15.566 20.3772 11.5523 20.2219 8.69507 21.2243ZM15.556 28.7622C14.786 28.9872 13.3163 29.4809 12.29 29.8598C10.0671 30.6802 6.69276 30.9832 4.43378 30.5651C3.53529 30.3987 2.80107 30.3486 2.80169 30.4537C2.80418 30.8762 4.00974 32.5699 4.97667 33.5098C7.86969 36.3216 13.3596 37.1348 17.9236 35.4272C20.2591 34.5532 22.8796 32.0342 23.1935 30.361C23.3117 29.731 23.3328 29.1396 23.2401 29.0472C22.4938 28.3008 17.7388 28.1244 15.556 28.7622Z"
			fill="currentColor"
		/>
	</svg>
);

export const UsersIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="50"
		height="50"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path d="M18 21a8 8 0 0 0-16 0" />
		<circle cx="10" cy="8" r="5" />
		<path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" />
	</svg>
);

export const FileCheckIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="50"
		height="50"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
		<path d="M14 2v5a1 1 0 0 0 1 1h5" />
		<path d="m9 15 2 2 4-4" />
	</svg>
);

export const BuildingIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="50"
		height="50"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<path d="M10 12h4" />
		<path d="M10 8h4" />
		<path d="M14 21v-3a2 2 0 0 0-4 0v3" />
		<path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" />
		<path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" />
	</svg>
);

export const ClipboardIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="50"
		height="50"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		{...props}
	>
		<rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
		<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
	</svg>
);

export const PlanUpgradeBackground = ({ className }: { className?: string }) => (
	<svg
		width="390"
		height="188"
		viewBox="0 0 390 188"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<g filter="url(#filter0_d_778_685)">
			<g filter="url(#filter1_i_778_685)">
				<rect
					x="316.428"
					y="24"
					width="110.571"
					height="110.571"
					fill="url(#paint0_linear_778_685)"
				/>
			</g>
			<g filter="url(#filter2_i_778_685)">
				<rect
					x="122.928"
					y="134.571"
					width="81.5464"
					height="81.5464"
					fill="url(#paint1_linear_778_685)"
				/>
			</g>
			<g filter="url(#filter3_i_778_685)">
				<path
					d="M204.475 134.571L316.428 24V134.571L204.475 216.118V134.571Z"
					fill="url(#paint2_linear_778_685)"
				/>
			</g>
			<path
				d="M427 134.571L368.006 216.118L204.475 216.118L316.429 134.571H427Z"
				fill="url(#paint3_linear_778_685)"
			/>
			<g filter="url(#filter4_i_778_685)">
				<path
					d="M40 216.506L122.929 134.571V216.506L40 276.932V216.506Z"
					fill="url(#paint4_linear_778_685)"
				/>
			</g>
		</g>
		<defs>
			<filter
				id="filter0_d_778_685"
				x="0"
				y="0"
				width="467"
				height="332.932"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="16" />
				<feGaussianBlur stdDeviation="20" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_778_685" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_778_685" result="shape" />
			</filter>
			<filter
				id="filter1_i_778_685"
				x="316.428"
				y="24"
				width="111.572"
				height="112.571"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="1" dy="2" />
				<feGaussianBlur stdDeviation="1" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
				<feBlend mode="overlay" in2="shape" result="effect1_innerShadow_778_685" />
			</filter>
			<filter
				id="filter2_i_778_685"
				x="122.928"
				y="134.571"
				width="81.5469"
				height="82.5464"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
				<feBlend mode="overlay" in2="shape" result="effect1_innerShadow_778_685" />
			</filter>
			<filter
				id="filter3_i_778_685"
				x="203.475"
				y="24"
				width="112.953"
				height="193.118"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="-1" dy="1" />
				<feGaussianBlur stdDeviation="1" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
				<feBlend mode="overlay" in2="shape" result="effect1_innerShadow_778_685" />
			</filter>
			<filter
				id="filter4_i_778_685"
				x="40"
				y="134.571"
				width="82.9277"
				height="144.361"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="2" />
				<feGaussianBlur stdDeviation="1" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
				<feBlend mode="overlay" in2="shape" result="effect1_innerShadow_778_685" />
			</filter>
			<linearGradient
				id="paint0_linear_778_685"
				x1="316.428"
				y1="24"
				x2="371.713"
				y2="151.157"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5E05C7" />
				<stop offset="1" stopColor="#9205AF" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_778_685"
				x1="122.928"
				y1="134.571"
				x2="149.188"
				y2="249.289"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#9A05B7" />
				<stop offset="1" stopColor="#5A05C9" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_778_685"
				x1="204.475"
				y1="120.75"
				x2="295.904"
				y2="84.3714"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5E05C7" />
				<stop offset="1" stopColor="#9205AF" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_778_685"
				x1="323.339"
				y1="134.571"
				x2="298.457"
				y2="230.854"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5E05C7" />
				<stop offset="1" stopColor="#9205AF" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_778_685"
				x1="103.579"
				y1="144.246"
				x2="150.218"
				y2="227.467"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5E05C7" />
				<stop offset="1" stopColor="#9205AF" />
			</linearGradient>
		</defs>
	</svg>
);